// extracted by mini-css-extract-plugin
export default {"advertWrapper":"ZxD9MoR4","advert":"mWsDCipk","placeholder":"AdUnit_placeholder__gjmv54pu","background":"AdUnit_background__4TWNlhV8","content":"AdUnit_content__s9ry45Rw"};